module.exports = __webpack_public_path__ + "img/GEL.fc60745d.svg";